 <!-- <div style="background: white;"> -->
  <div class="modal-container">
  <div class="modal-header-contratante">
    <span>Nuevo Beneficiario</span>
    <button type="button" class="btn-close" (click)="cerrar()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>

  </div>
  <!--modal-dialog-container-800-->
  <div class="beneficiary-dialog-content">
    <!--<div class="container"> -->
    <div class="container-fluid" style="padding: 0 15px;">
      <mat-tab-group [selectedIndex]="selectedIndex" [dynamicHeight]="true"
        (selectedTabChange)="tabOption($event, null)">
        <mat-tab label="DATOS BENEFICIARIO">
          <div class="beneficiario-datos-tab" [class.beneficiario-identidad-bloqueada]="datosIdentidadBeneficiarioBloqueados">
          <div class="row" style="margin-top: 16px;">
            <div class="col-md-12">
              <mat-label>Parentesco *</mat-label>
              <mat-form-field appearance="outline" class="responsive-form-field">
                <mat-select [(ngModel)]=" form.parentesco.value"
                  (selectionChange)="setRequiredMessage('parentesco','Parentesco')"
                  panelClass="custom-panel-responsive"
                  [disabled]="datosIdentidadBeneficiarioBloqueados">
                  <mat-option [value]="null">Seleccionar</mat-option>
                  <mat-option *ngFor="let item of parentescosParaSeleccion" [value]="item.id">{{item.parentesco}}</mat-option>
                </mat-select>
                <mat-hint style="color: red" *ngIf="form.parentesco.messages">{{form.parentesco.messages}}</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-md-6 col-lg-6">
              <mat-label>Tipo de documento *</mat-label>
              <mat-form-field appearance="outline" class="responsive-form-field">
                <mat-select [(ngModel)]="form.contratanteTipoDocumento.value"
                  (selectionChange)="setRequiredMessage('contratanteTipoDocumento','Tipo de documento'); getTypeDocument(); validateDocTypeWithAge();"
                  panelClass="custom-panel-responsive"
                  [disabled]="datosIdentidadBeneficiarioBloqueados">
                  <mat-option>Seleccionar</mat-option>
                  <mat-option *ngFor="let item of typeDocument" [value]="item.codigo"
                    [disabled]="isDocTypeDisabled(item)">
                    {{item.tipo_documento}}
                  </mat-option>
                </mat-select>
                <mat-hint style="color: red"
                  *ngIf="form.contratanteTipoDocumento.messages">{{form.contratanteTipoDocumento.messages}}
                </mat-hint>
              </mat-form-field>
            </div>

            <div class="col-xs-12 col-md-6 col-lg-6">
              <mat-label>Número de Documento *</mat-label>
              <mat-form-field appearance="outline">
                <input (keyup.enter)="!datosIdentidadBeneficiarioBloqueados && buscarPersona()" autocomplete="off"
                  (input)="checkPattern($event,'contratanteDocumento')"
                  (blur)="setRequiredMessage('contratanteDocumento','Número de Documento')"
                  [(ngModel)]="form.contratanteDocumento.value" matInput #message maxlength="30" placeholder="#"
                  [readonly]="datosIdentidadBeneficiarioBloqueados">
                <mat-icon (click)="!datosIdentidadBeneficiarioBloqueados && buscarPersona()" matSuffix
                  [style.cursor]="datosIdentidadBeneficiarioBloqueados ? 'not-allowed' : 'pointer'">search</mat-icon>
                <mat-hint align="start"><strong></strong> </mat-hint>
                <mat-hint align="end">
                  <label>
                    {{message.value.length}}
                  </label> / 30
                </mat-hint>
                <mat-hint style="color: red"
                  *ngIf="form.contratanteDocumento.messages">{{form.contratanteDocumento.messages}}
                </mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <mat-label>Nombre *</mat-label>
              <mat-form-field class="example-full-width" appearance="outline">
                <input autocomplete="off" (input)="checkPattern($event,'nombre')"
                  (blur)="setRequiredMessage('nombre','Nombre')" [(ngModel)]="form.nombre.value" matInput minlength="3"
                  maxlength="40" [readonly]="datosIdentidadBeneficiarioBloqueados">
                <mat-hint style="color: red" *ngIf="form.nombre.messages">{{form.nombre.messages}}
                </mat-hint>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-label>Segundo nombre</mat-label>
              <mat-form-field class="example-full-width" appearance="outline">
                <input autocomplete="off" (input)="checkPattern($event,'nombreSegundo')"
                  [(ngModel)]="form.nombreSegundo.value" matInput maxlength="40"
                  [readonly]="datosIdentidadBeneficiarioBloqueados">
                <mat-hint style="color: red" *ngIf="form.nombreSegundo.messages">{{form.nombreSegundo.messages}}
                </mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <mat-label>Primer apellido *</mat-label>
              <mat-form-field class="example-full-width" appearance="outline">
                <input autocomplete="off" (input)="checkPattern($event,'apellido')"
                  (blur)="setRequiredMessage('apellido','Primer apellido')" [(ngModel)]="form.apellido.value" matInput
                  minlength="3" maxlength="40" [readonly]="datosIdentidadBeneficiarioBloqueados">
                <mat-hint style="color: red" *ngIf="form.apellido.messages">{{form.apellido.messages}}
                </mat-hint>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-label>Segundo apellido</mat-label>
              <mat-form-field class="example-full-width" appearance="outline">
                <input autocomplete="off" (input)="checkPattern($event,'apellidoSegundo')"
                  [(ngModel)]="form.apellidoSegundo.value" matInput maxlength="40"
                  [readonly]="datosIdentidadBeneficiarioBloqueados">
                <mat-hint style="color: red" *ngIf="form.apellidoSegundo.messages">
                  {{form.apellidoSegundo.messages}}
                </mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="genero-field-row">
                <label class="genero-title" for="genF">Género *</label>

                <div class="genero-inline" role="radiogroup" aria-labelledby="genF">
                  <label class="radio-native" for="genF">
                    <input id="genF" type="radio" name="genero" value="1" [(ngModel)]="form.genero.value"
                      (change)="setRequiredMessage('genero','Género'); bucarCampa()"
                      [ngModelOptions]="{standalone:true}"
                      [disabled]="datosIdentidadBeneficiarioBloqueados" />
                    <span class="txt">F</span>
                  </label>
                  <label class="radio-native" for="genM">
                    <input id="genM" type="radio" name="genero" value="2" [(ngModel)]="form.genero.value"
                      (change)="setRequiredMessage('genero','Género'); bucarCampa()"
                      [ngModelOptions]="{standalone:true}"
                      [disabled]="datosIdentidadBeneficiarioBloqueados" />
                    <span class="txt">M</span>
                  </label>
                </div>
              </div>
              <mat-hint class="genero-hint" *ngIf="form.genero.messages">
                {{ form.genero.messages }}
              </mat-hint>
            </div>

            <div class="col-md-5">
              <mat-label>Fecha de nacimiento</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input id="txtFechaNacimiento" matInput [max]="maxDate" [min]="minDate"
                  (dateChange)="onFechaNacimientoChange($event); setRequiredMessage('fechaNacimiento','Fecha de nacimiento');"
                  [matDatepicker]="picker" [(ngModel)]="form.fechaNacimiento.value"
                  [readonly]="datosIdentidadBeneficiarioBloqueados">
                <mat-datepicker-toggle matSuffix [for]="picker"
                  [disabled]="datosIdentidadBeneficiarioBloqueados"></mat-datepicker-toggle>
                <mat-datepicker touchUi #picker></mat-datepicker>
                <mat-hint class="edad-error" *ngIf="form.fechaNacimiento.messages">
                  {{form.fechaNacimiento.messages}}</mat-hint>
              </mat-form-field>
            </div>

            <div class="col-md-1">
              <mat-label style="margin-right: 5%;">Edad</mat-label>
              <div>
                <div class="numberCircle">{{ edad === null ? '-' : edad }}</div>
              </div>
            </div>
          </div>

          <mat-dialog-actions
            class="consultar-actions"
            [class.with-alert]="!!form.fechaNacimiento.messages"
            align="center">
            <button class="btn-consultar" mat-raised-button color="primary" (click)="ejecutarConsultaBeneficiario()"
              [disabled]="!isFormValid()">
              CONSULTAR
            </button>
          </mat-dialog-actions>
          </div>
        </mat-tab>

        <!-- TAB 2: RESULTADOS BÚSQUEDA -->
        <mat-tab label="RESULTADO BÚSQUEDA" *ngIf="tabHabilitado.showResultTab && yaConsultoAdres">
          <div class="modal-body">
            <div class="row-resultados">

              <!-- Columna Izquierda -->
              <div class="columna-izquierda">
                <!-- Historial del cliente -->
                <div class="seccion-resultado">
                  <h4 class="titulo-seccion">Historial del cliente:</h4>
                  <div class="alerta-container">
                    <div *ngFor="let alerta of historialCliente" class="alerta-item"
                      [ngClass]="{'alerta-error': alerta.tipo === 'error','alerta-info': alerta.tipo === 'info','alerta-success': alerta.tipo === 'success'}">
                      <mat-icon
                        [ngClass]="{'icono-alerta': alerta.tipo === 'error','icono-info': alerta.tipo === 'info','icono-check': alerta.tipo === 'success'}">
                        {{ alerta.tipo === 'error' ? 'warning' : (alerta.tipo === 'info' ? 'info' : 'check_box') }}
                      </mat-icon>
                      <mat-label class="texto-alerta">{{alerta.mensaje}}</mat-label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Columna Derecha: Estado EPS -->
              <div class="columna-derecha" *ngIf="mostrarSeccionEPS">
                <div class="seccion-resultado">
                  <h4 class="titulo-seccion"> {{ tituloEstadoEPS }} </h4>
                  <ng-container *ngIf="esUsuario === true; else epsBeneficiario">
                    <div class="alerta-container">
                      
                      <div *ngIf="alertaEPSBeneficiario?.length === 0" class="alerta-item alerta-error">
                        <mat-icon class="icono-alerta">error</mat-icon>
                        <p class="texto-alerta">No hay información de EPS del contratante disponible.</p>
                      </div>
                      
                      <div *ngFor="let eps of alertaEPSBeneficiario" class="alerta-item" [ngClass]="{ 'alerta-success': eps.tipo === 'success', 'alerta-error': eps.tipo === 'error' }">
                        <mat-icon [ngClass]="eps.tipo === 'success' ? 'icono-check' : 'icono-alerta'"> {{ eps.tipo === 'success' ? 'check_box' : 'error' }} </mat-icon>
                        <p class="texto-alerta">{{ eps.mensaje }}</p>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #epsBeneficiario>
                    <div class="alerta-container">
                      <div *ngFor="let eps of estadoEPS" class="alerta-item" [ngClass]="{ 'alerta-success': eps.tipo === 'success', 'alerta-error': eps.tipo === 'error' }" role="status" aria-live="polite">
                        <mat-icon [ngClass]="eps.tipo === 'success' ? 'icono-check' : 'icono-alerta'"> {{ eps.tipo === 'success' ? 'check_box' : 'error' }} </mat-icon>
                        <p class="texto-alerta">{{ eps.mensaje }}</p>
                      </div>
                      <div *ngIf="(estadoEPS?.length || 0) === 0" class="alerta-item alerta-error">
                        <mat-icon class="icono-alerta">error</mat-icon>
                        <p class="texto-alerta">No se encontró información asociada a la EPS del beneficiario.</p>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer Tab Resultados -->
          <div class="modal-footer">
            <button type="button" class="btn-modal btn-elegir-programas" (click)="onElegirProgramasClick()">
              ELEGIR PROGRAMAS
            </button>
          </div>
        </mat-tab>

        <!-- TAB 3: ELECCIÓN PROGRAMA (solo si el contratante es usuario) -->
        <mat-tab label="ELECCIÓN PROGRAMA" *ngIf="tabHabilitado.showProgramTab">
          <div style="margin-top: 35px;">
            <div class="row" *ngIf="mostrarSwitchProgramasContratante">
              <div class="col-md-12 switch-container">
                <label class="custom-switch">
                  <mat-label class="switch-label-selector">Usar programas del contratante</mat-label>
                  <input type="checkbox" [(ngModel)]="usarProgramasContratante"
                    (change)="onToggleUsarProgramasContratante($event)" />
                  <span class="slider"></span>
                </label>
              </div>
            </div>

            <!-- Selector de Línea de Negocio -->
            <div class="selector-linea-negocio" style="margin-top: 15px;">
              <p class="label-selector">Selecciona la <strong>Línea de Negocio</strong></p>
              <div class="botones-linea-container">
                <button *ngFor="let linea of lineasNegocioDisponibles" type="button" class="btn-linea-negocio"
                  [class.btn-linea-seleccionada]="esLineaSeleccionada(linea.codigo)"
                  (click)="toggleLinea(linea.codigo)">
                  {{linea.nombre}}
                </button>
              </div>
            </div>

            <div *ngIf="anyCemFullSelected()" class="row cem-block" style="margin-top: 35px;">
              <div class="col-md-12">
                <div class="cem-title">VALIDACIÓN DEL ÁREA DE COBERTURA CEM</div>
                <div class="program-name">
                  Verifica si el programa CEM seleccionado cuenta con cobertura en la ubicación del usuario.
                </div>
              </div>

              <div class="col-md-3 mt-3">
                <mat-label class="cem-label">Tipo de Vía</mat-label>
                <mat-form-field appearance="outline" class="cem-field w-100">
                  <mat-select [(ngModel)]="form.tipoVia.value"
                    (selectionChange)="form.tipoVia.messages=''; coberturaCemValida=false; bucarCampa()">
                    <mat-option [value]="''" *ngIf="!form.tipoVia.value">Seleccionar</mat-option>
                    <mat-option *ngFor="let tv of tipoVias" [value]="tv.tipo_via">
                      {{ tv.tipo_via }} - {{ tv.nombre_tipo_via }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-3 mt-3">
                <mat-label class="cem-label">Número</mat-label>
                <mat-form-field appearance="outline" class="cem-field w-100">
                  <input matInput (keyup)="checkPattern($event,'numero'); coberturaCemValida=false; bucarCampa()"
                    [(ngModel)]="form.numero.value" placeholder="123" maxlength="10">
                </mat-form-field>
              </div>

              <div class="col-md-3 mt-3">
                <mat-label class="cem-label">Número de Placa</mat-label>
                <mat-form-field appearance="outline" class="cem-field w-100">
                  <input matInput (keyup)="checkPattern($event,'placaUno'); coberturaCemValida=false; bucarCampa()"
                    [(ngModel)]="form.placaUno.value" placeholder="123" maxlength="5">
                </mat-form-field>
              </div>

              <div class="col-md-3 mt-3">
                <mat-label class="cem-label">&nbsp;</mat-label>
                <div class="cem-placa-wrapper">
                  <span class="cem-dash">-</span>
                  <mat-form-field appearance="outline" class="cem-field w-100">
                    <input matInput (keyup)="checkPattern($event,'placaDos'); coberturaCemValida=false; bucarCampa()"
                      [(ngModel)]="form.placaDos.value" placeholder="123" maxlength="5">
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-6 mt-3">
                <mat-label class="cem-label">Municipio</mat-label>
                <mat-form-field appearance="outline" class="cem-field w-100">
                  <mat-select [(ngModel)]="form.ciudad.value"
                    (selectionChange)="setRequiredMessage('ciudad','Municipio'); coberturaCemValida=false; bucarCampa()">
                    <mat-option *ngFor=" let ciudad of ciudades" [value]="ciudad.codigo">
                      {{ ciudad.municipio }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-6 mt-4 d-flex" style="align-items: center;">
                <button mat-raised-button class="btn-linea-negocio cem-btn-validate"
                  (click)="validarCobertura()">VALIDAR
                  COBERTURA</button>
              </div>
             <!--
              <div class="col-md-12 mt-3">
                <div class="cem-map-info-box">
                  <mat-icon class="cem-map-info-icon">info</mat-icon>
                  <span class="cem-map-info-text">
                    Para ver el mapa de coberturas haga <a [href]="cemCoberturaUrl" target="_blank"
                      rel="noopener noreferrer" class="cem-link">clic aquí</a>
                  </span>
                </div>
              </div> -->
            </div>

            <!-- Grid de Programas con Imágenes -->
            <div class="modal-body">
              <p class="label-selector mb-3" *ngIf="hayLineasSeleccionadas">Selecciona el <strong>Programa</strong></p>

              <!-- Contenedor horizontal para las líneas de negocio -->
              <div class="contenedor-lineas-horizontal">
                <!-- Cada línea de negocio tiene su propio grid interno de 3 columnas -->
                <div *ngFor="let grupo of programasAgrupadosPorLinea; let last = last" class="grupo-linea-negocio">
                  <h3 class="titulo-linea-negocio">{{grupo.nombre}}</h3>
                  <div class="programas-grid">
                    <mat-card *ngFor="let programa of grupo.programas" class="programa-card"
                      [class.programa-seleccionado]="esProgramaSeleccionado(programa.id)"
                      (click)="toggleProgramaSeleccion(programa)">
                      <mat-card-content>
                        <div class="programa-imagen">
                          <!-- Mostrar imagen del carnet si está disponible, sino mostrar placeholder -->
                          <img *ngIf="programa.carnet" [src]="programa.carnet" [alt]="programa.nombre"
                            class="programa-carnet-img">
                          <div *ngIf="!programa.carnet" class="programa-placeholder"
                            [style.background]="programa.color">
                          </div>
                        </div>
                        <div *ngIf="esProgramaSeleccionado(programa.id)" class="check-overlay">
                          <mat-icon color="primary">check_circle</mat-icon>
                        </div>
                        <!-- Nombre del programa debajo de la imagen -->
                        <div class="programa-nombre-container">
                          <p class="programa-nombre-texto">{{programa.nombre}}</p>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                </div>
              </div>

              <!-- Sección de Configuración por Programa Seleccionado -->
              <div *ngIf="programasSeleccionados.length > 0" class="seccion-configuracion">
                <div *ngFor="let programaSel of programasSeleccionados; let i = index; trackBy: trackByProgramaId"
                  class="config-programa">
                  <h4 class="config-titulo">PROGRAMA {{programaSel.nombre.toUpperCase()}}:</h4>

                  <div class="config-anexos" *ngIf="shouldShowRequiereAnexo(programaSel)">
                    <div class="anexos-label">
                      ¿Requiere incluir anexos? *
                    </div>

                    <mat-radio-group [(ngModel)]="programaSel.requiereAnexo"
                      (ngModelChange)="onRequiereAnexoChange(programaSel)" class="anexos-radio-group"
                      aria-label="Requiere incluir anexos">
                      <mat-radio-button value="si" class="me-3">Sí</mat-radio-button>
                      <mat-radio-button value="no">No</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <div class="config-row">
                    <div class="config-col config-col-subcuenta"
                      *ngIf="debeMostrarSubcuenta && programaSel.subcuentasDisponibles.length > 0">
                      <label class="config-label">SUBCUENTA</label>
                      <mat-form-field appearance="outline" class="config-field subcuenta-field">
                        <mat-select [(ngModel)]="programaSel.subcuenta" 
                                    [ngModelOptions]="{standalone:true}" 
                                    placeholder="Seleccione" 
                                    (selectionChange)="onCambioSubcuenta(programaSel)" 
                                    [disabled]="isSubcuentaDisabled(programaSel)">
                          <mat-select-trigger>
                            <span class="subcuenta-trigger-text" [title]="getSubcuentaLabel(programaSel.id, programaSel.subcuenta)">
                              {{ getSubcuentaLabel(programaSel.id, programaSel.subcuenta) }}
                            </span>
                          </mat-select-trigger>
                          <mat-option *ngFor="let deno of programaSel.subcuentasDisponibles" [value]="deno">
                            {{ getSubcuentaLabel(programaSel.id, deno) }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="config-col">
                      <label class="config-label">TARIFA PROGRAMA</label>
                      <mat-form-field appearance="outline" class="config-field">
                        <mat-select [name]="'tarifa_'+programaSel.id" 
                                    [(ngModel)]="programaSel.tarifa" 
                                    (selectionChange)="onTarifaBeneficiarioChange(programaSel)" 
                                    [ngModelOptions]="{standalone:true}" 
                                    placeholder="Seleccione" 
                                    [disabled]="isTarifaSelectDisabled(programaSel) || isTarifaProgramaLocked(programaSel)">
                          
                          <mat-option *ngIf="tarifaProgramaFueraDeCatalogo(programaSel)" [value]="programaSel.tarifa">
                            {{ programaSel.tarifa }}
                          </mat-option>

                            <mat-option [value]="" *ngIf="!programaSel.tarifa">Seleccione</mat-option>
                            <mat-option *ngFor="let t of programaSel.tarifasDisponibles" [value]="t.tarifa"> 
                              {{ t.descripcion || t.description || t.tarifa }} 
                            </mat-option>
                          
                        </mat-select>
                      </mat-form-field>
                      <small class="config-hint-tarifa" *ngIf="getTarifaHintMessage(programaSel)"> 
                        {{ getTarifaHintMessage(programaSel) }} 
                      </small>
                    </div>

                    <div class="config-col" *ngIf="shouldShowTarifaAnexo(programaSel)">
                      <label class="config-label">TARIFA ANEXO</label>
                      <mat-form-field appearance="outline" class="config-field">
                        <mat-select [name]="'tarifaAnexo_' + programaSel.id" [(ngModel)]="programaSel.tarifaAnexo"
                          (selectionChange)="actualizarProgramasContratanteLocalStorage()"
                          [ngModelOptions]="{ standalone: true }" placeholder="Seleccione"
                          [disabled]="!programaSel.anexosDisponibles?.length || isTarifaAnexoLocked(programaSel)">
                          <mat-option value="">Seleccione</mat-option>
                          <mat-option *ngFor="let an of programaSel.anexosDisponibles" [value]="getAnexoOptionValue(an)">
                            {{ an.plan_desc }}
                          </mat-option>
                        </mat-select>
                        <mat-hint class="error-text" *ngIf="programaSel.__errors?.tarifaAnexo">
                          {{ programaSel.__errors?.tarifaAnexo }}
                        </mat-hint>
                      </mat-form-field>
                    </div>

                    <div class="config-col">
                      <label class="config-label">
                        CAMPAÑA
                        <mat-icon class="icono-ayuda-campania" #tooltipCampania="matTooltip"
                          [matTooltip]="getCampaniaTooltip(programaSel)" matTooltipPosition="right"
                          [matTooltipDisabled]="!programaSel.campana" (click)="tooltipCampania.toggle()" tabindex="0">
                          priority_high
                        </mat-icon>
                      </label>
                      <mat-form-field appearance="outline" class="config-field">
                        <mat-select [name]="'campana_'+programaSel.id" [(ngModel)]="programaSel.campana"
                          [ngModelOptions]="{standalone:true}" placeholder="Seleccione"
                          [disabled]="isCampanaSelectDisabled(programaSel)"
                          (selectionChange)="actualizarProgramasContratanteLocalStorage()">
                          <mat-option [value]="" *ngIf="!programaSel.campana">Seleccione</mat-option>
                          <mat-option *ngIf="hasCampaniaSeleccionadaFueraDeLista(programaSel)"
                            [value]="programaSel.campana">
                            {{ getCampaniaNombreVisible(programaSel) }}
                          </mat-option>
                          <mat-option *ngFor="let c of getCampaniasParaPrograma(programaSel)" [value]="c.codigo_campania">
                            {{ c.nombre }}
                           <span *ngIf="c.modalidad && (!esFlujoInclusion || c.modalidad !== 'NINGUNA')"> — {{ c.modalidad }}</span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <small class="config-hint-tarifa" *ngIf="getCampanaHintMessage(programaSel)">
                        {{ getCampanaHintMessage(programaSel) }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer Tab Programas -->
            <div class="modal-footer">
              <button *ngIf="guardar==true" class="btn-modal btn-guardar"
                [disabled]="!puedeGuardarProgramasSeleccionados()"
                (click)="agregar()">
                GUARDAR
              </button>
              <button *ngIf="guardar==false" class="btn-consultar"
                style="margin-right: 5%;background: #0372b9 !important" mat-raised-button color="primary"
                [disabled]="!puedeGuardarProgramasSeleccionados()"
                (click)="onActualizarBeneficiario()">ACTUALIZAR</button>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>